import styled from '@emotion/styled';
import { layout, palette, radius, shadow, spacing, typography } from '../../../../style-utils/theme';
import { up } from '../../../../style-utils/media-queries';

/**
 * THE CALENDAR SYNC TAB'S PARTS (plan S5, screens §1). Tokens only; no
 * component selectors (CRA has no emotion babel plugin).
 */

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  min-width: 0;
  padding-bottom: ${layout.fabReserve};
`;

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
  min-width: 0;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.md};
  background: ${palette.surface};
  box-shadow: ${shadow.sm};

  ${up('md')} {
    padding: ${spacing.md};
  }
`;

export const H3 = styled.h3`
  margin: 0;
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  font-weight: ${typography.weight.semibold};
  line-height: ${typography.leading.snug};
  color: ${palette.ink};
  overflow-wrap: anywhere;
`;

export const Muted = styled.p`
  margin: 0;
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  line-height: ${typography.leading.normal};
  color: ${palette.slate};
  overflow-wrap: anywhere;
`;

export const Rows = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const RowItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surface};

  ${up('md')} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
`;

export const RowMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  flex: 1 1 240px;
  min-width: 0;
`;

export const RowTitle = styled.span`
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
  overflow-wrap: anywhere;
`;

export const RowLine = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing.xs};
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
  line-height: ${typography.leading.normal};
  color: ${palette.slate};
  overflow-wrap: anywhere;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${spacing.xs};
  min-width: 0;
`;

export const Check = styled.label`
  display: flex;
  align-items: center;
  gap: ${spacing.xs};
  min-height: ${layout.touchTarget};
  padding: ${spacing.xs} ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.surface};
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.ink};
  cursor: pointer;

  input {
    flex: none;
    width: ${spacing.md};
    height: ${spacing.md};
    margin: 0;
    accent-color: ${palette.teal};
  }
`;

export const FormStack = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  min-width: 0;
`;

export const ReadOnly = styled.p`
  margin: 0;
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  color: ${palette.ink};
  overflow-wrap: anywhere;
`;

export const Reveal = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
  min-width: 0;
  margin-top: ${spacing.xs};
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.sm};
  background: ${palette.irisTintSoft};
`;
